/**
 * RESPONSIBILITY: run every generator once per section and remember the result.
 *
 * Sections are declared at module load and never change at runtime, so this is
 * derived once and reused. Regenerating a Zod schema on every request would be pure
 * waste on the hottest path in the server.
 */
import type { SectionMeta } from '../decorators';
import type { CompiledSection } from './types';
import { toJsonSchema } from './json-schema';
import { toUiSchema } from './ui-schema';
import { toZod } from './zod-schema';
import { defaultData } from './defaults';

const cache = new Map<string, CompiledSection>();

export function compile(section: SectionMeta): CompiledSection {
  const hit = cache.get(section.name);
  if (hit) return hit;

  const compiled: CompiledSection = {
    meta: section,
    dataSchema: toJsonSchema(section),
    uiSchema: toUiSchema(section),
    zod: toZod(section),
    defaults: defaultData(section),
  };

  cache.set(section.name, compiled);
  return compiled;
}
